/**
 * Dawn product form has novalidate — enforce cleaning-service required fields before add to cart.
 * Uses capture phase so validation runs before Dawn product-form Ajax handlers.
 */
(function () {
  const ERROR_MESSAGE = '必須項目をすべて入力してください。';

  function isFieldEmpty(field) {
    if (field.type === 'checkbox') return !field.checked;
    return String(field.value || '').trim() === '';
  }

  function validateRequired(requiredFields) {
    let firstInvalid = null;

    requiredFields.forEach((field) => {
      if (isFieldEmpty(field)) {
        if (!firstInvalid) firstInvalid = field;
        field.setCustomValidity('この項目は必須です');
      } else {
        field.setCustomValidity('');
      }
    });

    return firstInvalid;
  }

  function showValidationError(errorEl, firstInvalid) {
    if (errorEl) {
      errorEl.textContent = ERROR_MESSAGE;
      errorEl.hidden = false;
    }
    firstInvalid.focus({ preventScroll: false });
    firstInvalid.reportValidity();
  }

  function blockEvent(event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  function initCleaningProperties(wrapper) {
    const formId = wrapper.dataset.productFormId;
    const form = formId ? document.getElementById(formId) : wrapper.closest('form');
    if (!form || form.dataset.cleaningPropertiesBound === 'true') return;

    form.dataset.cleaningPropertiesBound = 'true';

    const errorEl = wrapper.querySelector('[data-cleaning-properties-error]');
    const requiredFields = wrapper.querySelectorAll('[required]');

    function clearError() {
      if (errorEl) errorEl.hidden = true;
    }

    requiredFields.forEach((field) => {
      field.addEventListener('input', clearError);
      field.addEventListener('change', clearError);
    });

    function guardSubmit(event) {
      const firstInvalid = validateRequired(requiredFields);
      if (!firstInvalid) return;

      blockEvent(event);
      showValidationError(errorEl, firstInvalid);
    }

    // capture: true — Dawn の product-form より先に実行
    form.addEventListener('submit', guardSubmit, { capture: true });

    // Dawn が submit 前に button click で処理する場合の保険
    const addButtons = form.querySelectorAll(
      'button[name="add"], input[name="add"], .product-form__submit'
    );
    addButtons.forEach((button) => {
      button.addEventListener('click', guardSubmit, { capture: true });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-cleaning-service-properties]').forEach(initCleaningProperties);
  }

  if (!window.__STATUS_CLEANING_PROPERTIES_INIT__) {
    window.__STATUS_CLEANING_PROPERTIES_INIT__ = true;

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', initAll);
  } else {
    initAll();
  }
})();